import React from 'react';
import PropTypes from 'prop-types';
import { StickyJumpNav } from 'components/facility/StickyJumpNav/StickyJumpNav';
import useBodyClassName from 'hooks/useBodyClassName';
import GTM_CLASSNAMES, { GTM_IDS } from 'utils/gtmSelectors';

import './StickyReserveBar.scss';

export function StickyReserveBar({
	sections,
	activeSection,
	onTabClick,
	reserveLabel = 'Reserve for Free',
	onReserveClick,
}) {
	// Lets the shared Footer reserve clearance only while this bar is
	// actually mounted, instead of unconditionally on every page.
	useBodyClassName('has-sticky-reserve-bar');

	return (
		<div className="sticky-reserve-bar">
			<StickyJumpNav
				links={sections}
				activeLink={activeSection}
				onLinkClick={onTabClick}
			/>
			<button
				type="button"
				// A plain <button>, not components/core/Button: react-core's
				// Button only forwards a fixed prop allow-list (no `id`) to
				// the DOM, which silently dropped this GTM hook.
				id={GTM_IDS.STICKY_RESERVE_BUTTON}
				className={GTM_CLASSNAMES.STICKY_RESERVE_BUTTON}
				onClick={onReserveClick}
			>
				{reserveLabel}
			</button>
		</div>
	);
}

StickyReserveBar.propTypes = {
	sections: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	activeSection: PropTypes.string,
	// Called as onTabClick(sectionId, event) - a plain handler, not a
	// curried factory.
	onTabClick: PropTypes.func.isRequired,
	reserveLabel: PropTypes.string,
	onReserveClick: PropTypes.func.isRequired,
};

export default StickyReserveBar;
